<template>
  <div class="gitex-hero">
    <div class="gitex-hero__info">
      <div class="gitex-hero__info-title">
        {{ $t('dfSpec') }}
        <br />
        {{ $t('for') }}
        <img
          :src="`${staticUrl}/images/gitex.webp`"
          alt=""
          class="gitex-hero__img"
        />
        {{ $t('morocco') }}
      </div>
      <div class="gitex-hero__info-desc">
        {{ $t('gitexHeroDes') }}
      </div>
      <div class="gitex-hero__info-actions">
        <GitexBtn @click="goToAnchor('#tariff')">
          {{ $t('forNewUsers') }}
        </GitexBtn>
        <GitexBtn
          :transparent="true"
          @click="goToAnchor('#investors')"
        >
          {{ $t('forInv') }}
        </GitexBtn>
      </div>
    </div>
    <img
      :src="`${staticUrl}/images/gitexHero.webp`"
      alt=""
      class="gitex-hero__img"
    />
  </div>
</template>

<script lang="ts" setup>
import GitexBtn from '../ui/GitexBtn.vue';
import {useRuntimeConfig} from '#imports';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;

function goToAnchor(id: string) {
  document
    .querySelector(id)
    ?.scrollIntoView({behavior: 'smooth', block: 'start'});
}
</script>

<style scoped lang="scss">
.gitex-hero {
  display: flex;
  gap: 24px;

  &__img {
    width: 552px;
    height: 500px;
    border-radius: 16px;
    object-fit: cover;
  }

  &__info {
    display: flex;
    justify-content: center;
    flex-direction: column;

    &-title {
      font-weight: 700;
      font-size: 48px;
      line-height: 120%;
      letter-spacing: 0.03em;
      color: #3d424a;

      img {
        display: inline;
        width: 175px;
        height: 44px;
      }
    }

    &-desc {
      margin-top: 16px;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      letter-spacing: 0.03em;
      color: #64686e;
    }

    &-actions {
      margin-top: 32px;
      display: flex;
      gap: 16px;
    }
  }
  @media (max-width: $lg) {
    flex-direction: column-reverse;
    gap: 16px;
    &__img {
      width: calc(100% + 32px);
      height: 428px;
      border-radius: initial;
      margin: 0px -16px;
    }

    &__info {
      &-title {
        font-size: 36px;
        line-height: 120%;
        letter-spacing: 0.03em;

        img {
          width: 134px;
          height: 33px;
          margin: 0px 4px;
        }
      }

      &-desc {
        margin-top: 8px;
        font-size: 15px;
        line-height: 140%;
        letter-spacing: 0.03em;
      }

      &-actions {
        flex-direction: column;
        gap: 16px;
      }
    }
  }
}
</style>
